import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { InvestmentBtn } from 'src/components/Global/Button/Button'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import BankTransfer from 'src/components/Payment/BankTransfer/BankTransfer'
import PaymentSelect from 'src/components/Payment/PaymentSelect/PaymentSelect'
import useUserData from 'src/hooks/useUserData'
import {
  getMyPlanByIdAction,
  topUpPlanAction,
} from 'src/redux/actions/planAction'
import { useTypedSelector } from 'src/redux/root-reducer'
import { PlanTypes } from 'src/redux/types/planTypes'
import { addNairaSign } from 'src/utils/addNairaSign'
import { usePaystack } from 'src/utils/paystack'
import { action } from 'typesafe-actions'
import { Wrapper } from './style'
import useSnackbar from 'src/hooks/useSnackBar'

const PaymentDetails = () => {
  let planPaymentData: any = useTypedSelector(
    (state) => state.userPlanReducer.paymentForm
  )
  useEffect(() => {
    dispatch(getMyPlanByIdAction(planPaymentData.id))
  }, [])
  const navigate = useNavigate()
  const [onIHavePaidModal, showOnIHavePaidModal] = useState(false)

  const { pay } = usePaystack()
  const plan = useTypedSelector((state) => state.userPlanReducer.getPlansById)

  const USER_DATA = useUserData()
  const checkType = () => {
    if (window.location.href.indexOf('general') > -1) {
      return 'General Savings'
    } else if (window.location.href.indexOf('target') > -1) {
      return 'Target Savings'
    } else if (window.location.href.indexOf('contest') > -1) {
      return 'X Contest'
    } else {
      return 'Quick Save'
    }
  }
  const type = checkType()
  const user_email = USER_DATA.user.email
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [option, setOption] = useState({
    name: 'card',
    data: '',
  })
  const [account, setAccount] = useState({
    account_number: '',
    account_name: '',
    bank_name: '',
  })
  const dispatch = useDispatch()

  const createPlan = (e: any) => {
    e.preventDefault()
    const payload = {
      plan: planPaymentData.id,
      amount: Number(planPaymentData.amount_to_save),
      channel: option.name,
      card: option.data,
      device: 'web',
    }
    if (payload.card === '' && payload.channel !== 'bank') {
      snackbar.trigger({
        message: 'Select a payment method',
        severity: 'warning',
      })
      return
    }
    setLoading(true)
    dispatch(
      topUpPlanAction({
        payload,
        onSuccess,
        onError,
      })
    )
  }
  const snackbar = useSnackbar()

  const onSuccess = (data: any) => {
    // console.log(data)
    setLoading(false)

    if (data.payment.bank_name) {
      onFundWithBankSuccess(data.payment)
    } else if (data.successful) {
      const payload = {
        reference: data.payment.reference,
        email: user_email,
        amount: planPaymentData.amount_to_save * 100,
      }
      const onPaySuccess = () => {
        console.log('successful')
        dispatch(action(PlanTypes.CLEAR_PAYMENT_FORM))
        snackbar.trigger({
          message: 'Payment successfully',
          severity: 'success',
        })
        setTimeout(() => {
          navigate('/homepage')
        }, 1500)
      }
      const onClose = () => {
        console.log('error')
      }
      pay(payload, onPaySuccess, onClose)
    } else {
      dispatch(action(PlanTypes.GET_USER_PLANS_CALL))
    }
  }

  const onError = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Something went wrong, please contact support.',
      severity: 'error',
    })
  }

  const onFundWithBankSuccess = (data: any) => {
    setTimeout(() => {
      setShowModal(true)
    }, 1000)
    setAccount({
      ...account,
      account_number: data?.account_number,
      bank_name: data?.bank_name,
    })

    console.log(data)
  }

  const onIHavePaid = (e: any) => {
    e.preventDefault()
    showOnIHavePaidModal(true)
  }

  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <h2 className="title">{type}</h2>
          <p className="desc">Here is a quick review of your {type}</p>
          <div className="description_wrapper">
            <div className="description">
              <p className="description_title">Amount to save</p>
              <p className="result">
                {addNairaSign(planPaymentData.amount_to_save)}
              </p>
            </div>
            {planPaymentData.saving_into && (
              <div className="description">
                <p className="description_title">You are saving into</p>
                <p className="result">{planPaymentData.saving_into}</p>
              </div>
            )}
            <div className="payment_section">
              <PaymentSelect
                option={option}
                setPayWithMethod={setOption}
                plan={plan}
              />
            </div>
          </div>
        </div>

        <div className="bank_transfer_wrapper">
          <BankTransfer
            account={account}
            amount={planPaymentData.amount_to_save}
            showModal={showModal}
            setShowModal={setShowModal}
            onIHavePaid={onIHavePaid}
            showOnIHavePaidModal={showOnIHavePaidModal}
            onIHavePaidModal={onIHavePaidModal}
          />
        </div>
        <InvestmentBtn onClick={createPlan}>
          Proceed {loading && <Spinner />}
        </InvestmentBtn>
      </form>
    </Wrapper>
  )
}

export { PaymentDetails }
